<script lang="ts" setup>
import { PageHeader } from '@/home/components/PageHeader';
import PageFooter from '@/home/components/PageFooter.vue';
import ScrollToTop from '@/home/components/ScrollToTop.vue';

defineOptions({
  name: 'LayoutNormal',
});
</script>

<template>
  <PageHeader />
  <slot></slot>
  <PageFooter />
  <ScrollToTop />
</template>

<style lang="scss" scoped>
</style>
